var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMydetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    viewBox: "0, 0, 24, 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,12 C9.243,12 7,9.757 7,7 C7,4.243 9.243,2 12,2 C14.757,2 17,4.243 17,7 C17,9.757 14.757,12 12,12 z M12,4 C10.346,4 9,5.346 9,7 C9,8.654 10.346,10 12,10 C13.654,10 15,8.654 15,7 C15,5.346 13.654,4 12,4 z M21,22 L3,22 C2.448,22 2,21.552 2,21 C2,16.589 6.486,13 12,13 C17.514,13 22,16.589 22,21 C22,21.552 21.552,22 21,22 z M4.111,20 L19.888,20 C19.252,17.166 15.956,15 11.999,15 C8.042,15 4.748,17.166 4.111,20 z",
    fill: "#FDF5F0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydetails);
export default __webpack_public_path__ + "static/media/mydetails.86f943d57a6ac0875a0a6eab7bc13038.svg";
export { ForwardRef as ReactComponent };